import {SET_TAX_FORMS_COUNTRIES_ACTION, TranslationAction} from '../actions/translation.actions';

export class TranslationState {
  countries: any[];
}

const initialState: TranslationState = <TranslationState>{
  countries: [],
};

export function translationReducer(state = initialState, action: TranslationAction): TranslationState {
  switch (action.type) {
    case SET_TAX_FORMS_COUNTRIES_ACTION:
      return {
        ...state,
        countries: action.countries
      };
    default:
      return state;
  }
}
